var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      ref: "modal",
      staticClass: "insurance_not_cover",
      attrs: {
        beforeCloseModal: _vm.beforeCloseModal,
        afterOpenModal: _vm.afterOpenModal,
        beforeOpenModal: _vm.beforeOpenModal,
        afterCloseModal: _vm.afterCloseModal,
      },
    },
    [
      _c("p", { staticClass: "insurance-not-cover-hint" }, [
        _vm._v(_vm._s(_vm.hint)),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
        _c(
          "button",
          {
            staticClass: "btn btn--darkblue",
            attrs: { type: "button" },
            on: { click: _vm.cancelBtn },
          },
          [_vm._v(_vm._s(_vm.$t("action.cancel")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn--orange",
            attrs: { type: "button" },
            on: { click: _vm.continueBtn },
          },
          [_vm._v(_vm._s(_vm.$t("action.continue")))]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }